import { render, staticRenderFns } from "./PlusMoreIcon.vue?vue&type=template&id=5454018f"
import script from "./PlusMoreIcon.vue?vue&type=script&lang=js"
export * from "./PlusMoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports